import axios from 'axios';

const api = axios.create({
    baseURL: 'https://api.erp-web.com'
})

export default api;